declare const __MOCKUP_API_BASE_URL__: string | undefined;
declare const __MOCKUP_ASSETS_BASE_URL__: string | undefined;
declare const __MOCKUP_APP_URL__: string | undefined;

const CONFIGURED_API_BASE_URL = (__MOCKUP_API_BASE_URL__ || '').trim().replace(/\/$/, '');
const CONFIGURED_ASSETS_BASE_URL = (__MOCKUP_ASSETS_BASE_URL__ || '').trim().replace(/\/$/, '');
const SAME_ORIGIN_API_BASE_URL =
  typeof window === 'undefined' ? '' : `${window.location.protocol}//${window.location.host}`;

export const API_BASE_URL = CONFIGURED_API_BASE_URL || SAME_ORIGIN_API_BASE_URL;
export const ASSETS_BASE_URL = CONFIGURED_ASSETS_BASE_URL;
export const INDEX_URL = `${API_BASE_URL}/mockups/index.json`;
export const MOTION_EXPORT_SESSIONS_URL = `${API_BASE_URL}/motion-export-sessions`;

/** Public URL of the web app. Used to build browser export links when the code
 *  runs inside a Figma plugin iframe where window.location.href is not reliable. */
export const APP_URL = (__MOCKUP_APP_URL__ || '').trim().replace(/\/$/, '');

/** Resolve public catalog media through the optional CDN while keeping API and
 * runtime URLs on their original origin. Only /mockups/* is CDN-eligible. */
export function resolvePublicAssetUrl(value: string, fallbackBaseUrl: string): URL {
  const resolved = new URL(value, fallbackBaseUrl);
  if (!ASSETS_BASE_URL || !resolved.pathname.startsWith('/mockups/')) {
    return resolved;
  }

  const cdnUrl = new URL(resolved.pathname, `${ASSETS_BASE_URL}/`);
  cdnUrl.search = resolved.search;
  cdnUrl.hash = resolved.hash;
  return cdnUrl;
}
